export interface LinkSchedulerObject {
    startDate: Date;
    isRecurring: boolean
    recurringGroup: RecurringGroup
    linkId: number;
  }

  export interface RecurringGroup {
    recurrencePeriodicity: number
    endRecurrence: EndRecurrence
    hourlyRecurrenceGroup: HourlyRecurrenceGroup
    dailyRecurrenceGroup: DailyRecurrenceGroup
    weeklyRecurrenceGroup: WeeklyRecurrenceGroup
    monthlyRecurrenceGroup: MonthlyRecurrenceGroup
    yearlyRecurrenceGroup: YearlyRecurrenceGroup
  }

  export enum recurrencePeriodicityEnum
  {
    UNKNOWN = 0,
    HOURLY = 1,
    DAILY = 2,
    WEEKLY = 3,
    MONTHLY = 4
  }

  export interface EndRecurrence {
    endRecurrenceType: endRecurrenceTypeEnum
    endRecurrenceDate: Date;
    endRecurrenceCount: number
  }

  export enum endRecurrenceTypeEnum {
    NEVER = 1,
    ONDATE = 2,
    ONCOUNT = 3,
  }

  export interface HourlyRecurrenceGroup {
    hourlyRecurrenceEveryXHours: number
  }

  export interface DailyRecurrenceGroup {
    dailyRecurrenceEveryXDays: number
  }

  export interface WeeklyRecurrenceGroup {
    weeklyRecurrenceyEveryXWeeks: number
    weeklyRecurrenceRepeatOnDays: any
  }

  export interface MonthlyRecurrenceGroup {
    monthlyRecurrenceEveryXMonths: number
    monthlyRecurrenceRepeatOnDay: number
  }

  export interface YearlyRecurrenceGroup {
    yearlyRecurrenceEveryXYears: number
    yearlyRecurrenceRepeatOnDate: any
  }
